exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".no-consent-section{display:flex;flex-wrap:wrap;justify-content:center;padding-top:5em;padding-bottom:5em}.no-consent-section .button-section{text-align:center;padding-top:2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Securian/WL/DidNotConsent.scss
// module id = 8033
// module chunks = 13